import React from 'react'
import { connect } from 'react-redux'

import ClientContainer from '../../containers/clientContainer'
import {
  checkNonForfaitToken,
    stopCheckoutLoading,
    saveQueryParams,
    fetchServiceAndAddToCart,
    checkQueryParams
} from './actions'

import './styles.css'
import { loadClientByPlate } from "./checkoutContent/actions"
import { loadWorkShopData, authAutocare } from "./workshop/actions"
import { configuration } from '../../configuration'

class Checkout extends React.Component {

    componentWillMount() {
        this.props.authAutocare(configuration().workshopEmailHash, () => {
            // En caso de error, redireccionamos al widget.
            this.props.history.push('/bad-request')
        });
    }

    componentDidMount() {
        document.body.style.backgroundColor = "#ebebec";
        document.body.style.backgroundImage = 'none';
    }

    componentDidUpdate(prevProps){
        if(prevProps.workshop.token !== this.props.workshop.token){
            this.props.loadClientByPlate(this.props.clientCarPlate)
            this.props.loadWorkShopData(configuration().workshopEmailHash)
        }
    }

    componentWillUnmount() {
        document.body.removeAttribute('style')
    }

    render() {
        return <ClientContainer />
    }
}

const mapStateToProps = state => ({
    checkoutStore: state.checkout.checkoutRoot,
    clientCarPlate: state.checkout.carData.clientCarPlate,
    workshop: state.checkout.workshop
});

const bindActions = dispatch => ({
    fetchServiceAndAddToCart: serviceId => dispatch(fetchServiceAndAddToCart(serviceId)),
    checkNonForfaitToken: token => dispatch(checkNonForfaitToken(token)),
    stopLoading: () => dispatch(stopCheckoutLoading()),
    loadClientByPlate: plate => dispatch(loadClientByPlate(plate)),
    loadWorkShopData: emailHash => dispatch(loadWorkShopData(emailHash)),
    authAutocare: (data, cb_error) => dispatch(authAutocare(data, cb_error)),
    saveQueryParams: params => dispatch(saveQueryParams(params)),
    checkQueryParams: (params, cb) => dispatch(checkQueryParams(params, cb)),
});

export default connect(mapStateToProps, bindActions)(Checkout);



// WEBPACK FOOTER //
// ./src/workflow/checkout/index.js